<template>
  <section class="flex justify-center">
    <div class="w-full py-8 md:px-8">
      <div class="px-2 pt-2">
        <!-- Ícone de Sucesso -->
        <div class="flex justify-center mb-6">
          <div
            class="icon-circle"
            :style="{ backgroundColor: thankYouPage?.icon_background_color || '#10b981' }"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="60"
              height="60"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                :fill="thankYouPage?.icon_color || '#ffffff'"
              />
            </svg>
          </div>
        </div>

        <!-- Mensagem Principal -->
        <div
          class="text-center mb-8 font-semibold"
          :style="{
            color: thankYouPage?.message_color || '#111827',
            fontSize: thankYouPage?.message_size || '24px'
          }"
        >
          {{ parseMessage(thankYouPage?.message_text) }}
        </div>

        <!-- Código de Confirmação -->
        <div
          v-if="thankYouPage?.show_confirmation_code && confirmationCode"
          class="confirmation-code-box"
        >
          <small class="text-muted">Código de Confirmação</small>
          <div class="confirmation-code">{{ confirmationCode }}</div>
        </div>

        <!-- Box Importante -->
        <div
          v-if="thankYouPage?.important_box_enabled"
          class="important-box"
        >
          <!-- Título do Box -->
          <div v-if="thankYouPage?.important_box_title" class="important-box-title">
            {{ thankYouPage.important_box_title }}
          </div>

          <!-- Conteúdo do Box -->
          <div v-if="thankYouPage?.important_box_content" class="important-box-content" v-html="formatContent(parseMessage(thankYouPage.important_box_content))"></div>

          <!-- Botão de Ação -->
          <div
            v-if="thankYouPage?.button_enabled && thankYouPage?.button_text"
            class="button-wrapper"
          >
            <a
              :href="thankYouPage.button_url || '#'"
              class="action-button"
              :style="{
                backgroundColor: thankYouPage.button_color || '#556ee6',
                color: thankYouPage.button_text_color || '#ffffff'
              }"
              :target="thankYouPage.button_url ? '_blank' : '_self'"
            >
              {{ thankYouPage.button_text }}
            </a>
          </div>
        </div>

        <!-- Contador de Redirecionamento -->
        <div v-if="thankYouPage?.redirect_enabled && redirectCountdown > 0" class="redirect-countdown">
          Você será redirecionado em {{ redirectCountdown }} segundo{{ redirectCountdown !== 1 ? 's' : '' }}...
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { computed, ref, onMounted, onBeforeUnmount } from 'vue';

export default {
  name: 'DynamicThankYouPage',
  props: {
    thankYouPage: {
      type: Object,
      default: null
    },
    participant: {
      type: Object,
      default: null
    },
    confirmationCode: {
      type: String,
      default: null
    }
  },
  setup(props) {
    const redirectCountdown = ref(0);
    let redirectInterval = null;

    const parseMessage = (text) => {
      if (!text) return '';

      let parsed = text;

      // Substitui {Nome}
      if (props.participant?.name) {
        parsed = parsed.replace(/{Nome}/g, props.participant.name);
      }

      // Substitui {Email}
      if (props.participant?.email) {
        parsed = parsed.replace(/{Email}/g, props.participant.email);
      }

      // Substitui {CodigoConfirmacao}
      if (props.confirmationCode) {
        parsed = parsed.replace(/{CodigoConfirmacao}/g, props.confirmationCode);
      }

      return parsed;
    };

    const formatContent = (text) => {
      if (!text) return '';
      // Converte quebras de linha em <br>
      return text.replace(/\n/g, '<br>');
    };

    const startRedirectCountdown = () => {
      if (!props.thankYouPage?.redirect_enabled || !props.thankYouPage?.redirect_url) {
        return;
      }

      const timer = props.thankYouPage.redirect_timer || 5;
      redirectCountdown.value = timer;

      redirectInterval = setInterval(() => {
        redirectCountdown.value--;

        if (redirectCountdown.value <= 0) {
          clearInterval(redirectInterval);
          window.location.href = props.thankYouPage.redirect_url;
        }
      }, 1000);
    };

    onMounted(() => {
      startRedirectCountdown();
    });

    onBeforeUnmount(() => {
      if (redirectInterval) {
        clearInterval(redirectInterval);
      }
    });

    return {
      parseMessage,
      formatContent,
      redirectCountdown
    };
  }
};
</script>

<style scoped>
.icon-circle {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.confirmation-code-box {
  margin: 2rem 0;
  padding: 1.5rem;
  background: #f9fafb;
  border-radius: 8px;
  text-align: center;
}

.text-muted {
  color: #6b7280;
  font-size: 14px;
}

.confirmation-code {
  font-size: 20px;
  font-weight: 700;
  color: #374151;
  letter-spacing: 2px;
  margin-top: 0.5rem;
  font-family: 'Courier New', monospace;
}

.important-box {
  margin: 2rem 0;
  padding: 1.5rem;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  text-align: left;
}

.important-box-title {
  font-size: 13px;
  font-weight: 700;
  color: #374151;
  text-align: center;
  margin-bottom: 1rem;
  letter-spacing: 0.5px;
}

.important-box-content {
  color: #6b7280;
  font-size: 14px;
  line-height: 1.6;
  text-align: center;
  margin-bottom: 0;
}

.button-wrapper {
  margin-top: 1.5rem;
  text-align: center;
}

.action-button {
  display: inline-block;
  padding: 8px 32px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.action-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  text-decoration: none;
  opacity: 0.9;
}

.redirect-countdown {
  margin-top: 2rem;
  padding: 1rem;
  text-align: center;
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
  background: #f3f4f6;
  border-radius: 8px;
}
</style>
